<template>
    <common-widget>
        <common-widget-header
            v-if="!$auth.isPracticeAncillary()"
            :heading="$t('elements.home.rating.heading.professional.heading')"
            :hint="$t('elements.home.rating.heading.professional.info')"
        ></common-widget-header>
        <common-widget-header v-else :heading="$auth.getPractice().name"></common-widget-header>
        <common-widget-content :isCenter="true">
            <common-ancillary-avatar
                v-if="$auth.isPracticeAncillary()"
                :ancillary="$auth.getPractice()"
                size="member-switch"
            ></common-ancillary-avatar>
            <common-rating-pie v-if="!$auth.isPracticeAncillary()" :rating="professionalRating"></common-rating-pie>
        </common-widget-content>
        <register-practice-reminder v-if="showPracticeReminder" class="complete-profile-reminder"></register-practice-reminder>
        <profile-completion-reminder
            v-else-if="showCompleteProfileReminder"
            class="complete-profile-reminder"
        ></profile-completion-reminder>
        <common-widget-header
            class="widget__pt-35"
            :heading="$t('elements.home.rating.heading.medmatch.heading')"
            :hint="$t('elements.home.rating.heading.medmatch.info')"
        ></common-widget-header>

        <common-widget-content :isCenter="true">
            <common-rating-stars :rating="rating"></common-rating-stars>
        </common-widget-content>
    </common-widget>
</template>

<script>
    import ProfileCompletionReminder from './profile/ProfileCompletionReminder.vue'
    import RegisterPracticeReminder from './practice/RegisterPracticeReminder'
    import UserRolesEnum from '../../enums/UserRolesEnum'

    export default {
        components: {
            ProfileCompletionReminder,
            RegisterPracticeReminder,
        },

        props: {
            professionalRating: { type: [String, Number], default: undefined },
            rating: { type: [String, Number], default: undefined },
        },

        data() {
            return {
                isProfileComplete: this.$auth.getActiveMember().isProfileComplete,
                isNpiVerified: this.$auth.getActiveMember().isNpiVerified,
            }
        },

        computed: {
            showCompleteProfileReminder() {
                if (this.$auth.isPracticeOther()) {
                    return false
                }
                const isAncillary = this.$auth.isPracticeAncillary()
                if (isAncillary) {
                    return !(this.isInsuranceSelected && this.isServiceSelected)
                } else {
                    return !(this.isInsuranceSelected && this.isNpiVerified)
                }
            },
            showProfileReminder() {
                const userRoleId = this.$auth.getUser().userRole?.id
                if (
                    !this.$auth.getActiveMember()?.isProfileComplete &&
                    [UserRolesEnum.PHYSICIAN.ID, UserRolesEnum.OFFICE_MANAGER.ID, UserRolesEnum.NURSE_PRACTITIONER.ID].includes(
                        userRoleId,
                    )
                ) {
                    return true
                }
                return false
            },
            showPracticeReminder() {
                return (
                    (this.$auth.isUserPracticeOther() || this.$auth.isUserTemporaryPhysician()) &&
                    (!this.$auth.getPractice() || !this.$auth.getPractice().id)
                )
            },

            isInsuranceSelected() {
                if (this.$auth.getPractice()?.insurancePlans?.length > 0) {
                    const onlySelfPay =
                        this.$auth.getPractice().insurancePlans.length === 1 &&
                        this.$auth.getPractice().insurancePlans[0].name.toLowerCase() === 'self-pay'
                    return !onlySelfPay
                } else {
                    return false
                }
            },

            isServiceSelected() {
                if (this.$auth.getPractice()?.facilityServiceTypes?.length > 0) {
                    const allHaveGroupsAndSubgroups = this.$auth.getPractice().facilityServiceTypes.every((serviceType) => {
                        if (serviceType.facilityServiceTypesGroups.length === 0) {
                            return false
                        }

                        return serviceType.facilityServiceTypesGroups.every(
                            (group) => group.facilityServiceTypesSubgroups.length > 0,
                        )
                    })

                    return allHaveGroupsAndSubgroups
                } else {
                    return false
                }
            },
        },
    }
</script>
